
import { Component, Vue, Watch } from "vue-property-decorator";
import CommissionService from "@/services/auth/CommissionService";
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";

import "datatables.net-fixedcolumns-bs4";

import "datatables.net";
import "datatables.net-colreorder-dt";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import { Money } from "v-money";
import JSZip from "jszip";
import DateRangePicker from "vue2-daterange-picker";
import vSelect from "vue-select";
import UserService from "@/services/auth/UserService";
import SquadService from "@/services/auth/SquadService";
import moment from "moment-timezone";
import { mapGetters } from "vuex";

@Component({
  components: {
    LayoutDefault,
    DateRangePicker,
    vSelect,
    Money,
  },
  computed: {
   ...mapGetters('auth', ['allowedFeature'])
  }
})
export default class Commission extends Vue {

  /**
   * @type Object
   * Data list commission from return backend
   */
  private listCommission: any;

  /**
   * @type Instance
   * For manager data on lead backend routesf
   */
  private commissionService = new CommissionService();

  /**
   * @type Object
   * contains data from run filter on list commissions
   */
  private filter: any = {
    date: {
      startDate: "",
      endDate: ""
    }
  };

  private bonusComission: any = {
    date: "",
    bonus_id: null,
    bonus_value: 0,
    squad_id: null,
    note: "",
    user_id: null
  };

  private moneyMask: any = {
    decimal: ".",
    thousands: "",
    prefix: "",
    suffix: "",
    precision: 2,
    masked: true /* doesn't work with directive */,
  };

  /**
   * @type
   * Help to control show loading icon
   */
  private loading: boolean = false;
  private saveMemory: boolean = false;

  /**
   * @type Array
   * Define columns from datatables
   */
  private columns = [
    /*
    * data, comissão, ações, total vendido (qtd), total vendido (valor),
    * taxa de conversao, gatilho, valor de gatilho, ganho de gatilho,
    * fee fixo, valor por atendimento, comissão total por atendimento
    */
    {
        data: "id_commission_history",
        name: "id_commission_history",
        title: "ID",
        defaultContent: "--",
        searchable: false,
        orderable: false,
        visible: true,
    },
    {
      data: "commission_date",
      name: "commission_date",
      title: "Data",
      defaultContent: "--",
      searchable: false,
      orderable: false,
      visible: true,
    },
    {
      data: "commission_value",
      name: "commission_value",
      title: "Total de comissão",
      defaultContent: "--",
      searchable: true,
      orderable: false,
      visible: true,
    },
    {
      data: "platform",
      name: "platform",
      title: "Plataforma",
      defaultContent: "--",
      searchable: true,
      orderable: false,
      visible: true,
    },
    {
      data: "actions",
      name: "actions",
      title: "Ações",
      defaultContent: "--",
      searchable: true,
      orderable: false,
      visible: true,
    },
    {
      data: "commission_sales",
      name: "commission_sales",
      title: "Comissão por vendas",
      defaultContent: "--",
      searchable: true,
      orderable: false,
      visible: true,
    },
    {
      data: "commission_attendances",
      name: "commission_attendances",
      title: "Comissão por contatos produtivos",
      defaultContent: "--",
      searchable: true,
      orderable: false,
      visible: true,
    },
    {
      data: "sales_amount",
      name: "sales_amount",
      title: "Quantidade de conversões",
      defaultContent: "--",
      searchable: true,
      orderable: false,
      visible: true,
    },
    {
      data: "attendances_amount",
      name: "attendances_amount",
      title: "Quantidade de contatos produtivos",
      defaultContent: "--",
      searchable: true,
      orderable: false,
      visible: true,
    },
    {
      data: "conversion_rate",
      name: "conversion_rate",
      title: "Taxa de conversão",
      defaultContent: "--",
      searchable: true,
      orderable: false,
      visible: true,
    },
    {
      data: "sales_value",
      name: "sales_value",
      title: "Valor vendido",
      defaultContent: "--",
      searchable: true,
      orderable: false,
      visible: true,
    },
    {
      data: "trigger_label",
      name: "trigger_label",
      title: "Gatilho alcançado",
      defaultContent: "--",
      searchable: true,
      orderable: false,
      visible: true,
    },
    {
      data: "trigger_value",
      name: "trigger_value",
      title: "Valor do gatilho",
      defaultContent: "--",
      searchable: true,
      orderable: false,
      visible: true,
    },
    {
      data: "trigger_earnings",
      name: "trigger_earnings",
      title: "Ganho do gatilho",
      defaultContent: "--",
      searchable: true,
      orderable: false,
      visible: true,
    },
    {
      data: "commission_daily_minimum",
      name: "commission_daily_minimum",
      title: "Fee fixo",
      defaultContent: "--",
      searchable: true,
      orderable: false,
      visible: true,
    },
    {
      data: "per_attendance_value",
      name: "per_attendance_value",
      title: "Valor por contato produtivo",
      defaultContent: "--",
      searchable: true,
      orderable: false,
      visible: true,
    },
    {
      data: "is_golden_day",
      name: "is_golden_day",
      title: "Dia de Ouro",
      defaultContent: "--",
      searchable: true,
      orderable: false,
      visible: true,
    },
    {
      data: "bonus",
      name: "bonus",
      title: "Bonus",
      defaultContent: "--",
      searchable: true,
      orderable: false,
      visible: true,
    },
    {
      data: "commission_bonus_description",
      name: "commission_bonus_description",
      title: "Descrição do Bonus",
      defaultContent: "--",
      searchable: true,
      orderable: false,
      visible: true,
    }
  ];

  /**
   * @type Array
   * Set config for buttons datatable
   */
  private buttons: any = [];
  private disabledCommissionInput = false;
  private totalCommissions: number = 0;
  private sumCommissions: number = 0;
  private exportFormat: string = "csvHtml5";
  private listBonus:any = [];
  private listSquad:any = [];
  private user_squad:any ={
      id_user: this.$auth.user().id_user,
      name: this.$auth.user().name,
  };
  private userSelected:any = {
      id_user: this.$auth.user().id_user
  };
  private bonusSelected:any;
  /**
   * Method created life cycle
   */
  private created() {
    let self = this;
    this.bonusSelected = null;

   // (window as any).JSZip = JSZip;
  }
  /**
   * Method filter list commission
   */
  private async sendFilter() {
    this.listCommission.ajax.reload();
    this.hideModal("modal-filter");
    const commission = await this.commissionService.commissionStatement(this.mountedFilter());

    this.sumCommissions = commission.data.reduce(
        (a, b) => a + parseFloat(b.commission_value.replace('R$', '').replace(',', '.')), 0
    );
  }

  /**
   * Method to clerar filters on list commission
   */
  private clearFilter() {
    this.filter.date = {
      startDate: "",
      endDate: ""
    };

    this.listCommission.ajax.reload();
    this.hideModal("modal-filter");
  }

  /**
   * Method to clerar filters on list commission
   */
  private clearBonus() {
    this.dateRangeBonus = {
      startDate: "",
      endDate: ""
    }

    this.bonusComission = {
      date: "",
      bonus_id: null,
      bonus_value: 0,
      squad_id: null,
      user_id: null
    };


    this.hideModal("modal-add-bonus");
  }

  private dateRangeBonus = {
    startDate: "",
    endDate: ""
  }
  @Watch("dateRangeBonus.startDate")
  onChangeSaleDate(value: any, _oldValue: any) {
    this.bonusComission.date = value;
  }

  private limitDateSale  = this.$moment().add(-1, "day").format('YYYY-MM-DD HH:mm:ss');

  private selectBonus(){
    if (this.bonusComission.bonus_id.value == null) {
      this.disabledCommissionInput = false;
    } else {
      this.disabledCommissionInput = true;
    }

    this.bonusComission.bonus_value = this.bonusComission.bonus_id.value;
  }

  private mountedFilter() {
    let req: any = {};

    if (this.filter.date.startDate) {
      let startDate = (this.$moment(this.filter.date.startDate) as any).format("YYYY-MM-DD");
      let endDate = (this.$moment(this.filter.date.endDate) as any).format("YYYY-MM-DD");
      req.filter = { startDate, endDate };
    }

    req.id_platform = this.$auth.user().id_platform;
    req.id_user = this.userSelected.id_user;
    if (req.filter) req.filter = JSON.stringify(req.filter);
    return req;
  }

  /**
   * Method join commands for create datatable
   */
  private createDataTable(self) {
    this.buttons.push({
    extend: "collection",
    text: '<i class="fas fa-file-export"></i>',
    titleAttr: "Exportar",
    className: "datatable-buttons mr-2 pr-0 pl-0",
    autoClose: true,
    buttons: [
        {
          extend: "excelHtml5",
          text: "Excel",
          titleAttr: "Excel",
          exportOptions: {
              columns: ":visible",
          },
          action: async (e, dt, node, config) => {
              this.$bvModal.show("modal-export-data");
              this.exportFormat = "excelHtml5";
          },
        },
        {
          extend: "csvHtml5",
          text: "CSV",
          titleAttr: "CSV",
          exportOptions: {
              columns: ":visible",
          },
          action: async (e, dt, node, config) => {
              this.$bvModal.show("modal-export-data");
              this.exportFormat = "csvHtml5";
          },
        },
        {
          extend: "copyHtml5",
          text: "Clipboard",
          titleAttr: "Clipboard",
          exportOptions: {
              columns: ":visible",
          },
        },
    ],
    });

    this.buttons.push({
      extend: "filter",
    });

    if(self.allowedFeature('create-commission')){
        this.buttons.push({
        extend: "addbonus",
        });
    }

    // init datatable
    this.listCommission = this.$("#listCommission")
      .on("preXhr.dt", async (e, settings, d) => {})
      .on("xhr.dt", (e, settings, d, xhr) => {
        if (this.listCommission.ajax.json() !== undefined) {
          this.totalCommissions = this.listCommission.ajax.json().recordsTotal;

          let res = xhr.responseJSON.data;

          for (let [i, c] of Object.entries(this.columns)) {
            this.listCommission.column(i).visible(!res.every((r) => !r[c.name]));
          }
        }

        if (xhr.status !== 200)
          this.$store.commit("navBarAlert/DANGER_ALERT", 'Erro ao carregar a listagem. Por favor, tente novamente mais tarde.');
      })
      .DataTable({
        autoWidth: true,
        responsive: true,
        processing: true,
        serverSide: false,
        colReorder: false,
        searchDelay: 1000,
        lengthMenu: [
          [10, 25, 100, 500, 1000, 2000, 3000],
          [10, 25, 100, 500, "1000", "2000", "3000"],
        ],
        pageLength: 10,
        scrollY: 500,
        scrollX: true,
        bSort: false,
        language: {
          sEmptyTable: "Nenhum registro encontrado",
          sInfo: "Mostrando de _START_ até _END_ de _TOTAL_ registros",
          sInfoEmpty: "Mostrando 0 até 0 de 0 registros",
          sInfoFiltered: "(Filtrados de _MAX_ registros)",
          sInfoPostFix: "",
          sInfoThousands: ".",
          sLengthMenu: "_MENU_ Qtd por página",
          sLoadingRecords: "Carregando...",
          sProcessing:
            '<div><div class="row justify-content-center m-5"><span role="status" class="spinner-border" style="width: 3rem; height: 3rem;"></span></div><div class="row justify-content-center mt-5">Loading ...</div></div>',
          sZeroRecords: "Nenhum registro encontrado",
          sSearch: "Pesquisar",
          oPaginate: {
            sNext: "Próximo",
            sPrevious: "Anterior",
            sFirst: "Primeiro",
            sLast: "Último",
          },
          oAria: {
            sSortAscending: ": Ordenar colunas de forma ascendente",
            sSortDescending: ": Ordenar colunas de forma descendente",
          },
          select: {
            rows: {
              _: "Selecionado %d linhas",
              "0": "Nenhuma linha selecionada",
              "1": "Selecionado 1 linha",
            },
          },
        },
        ajax: {
          url: process.env.VUE_APP_ROOT_API + "auth/user/commission/statement",
          crossDomain: true,
          type: "GET",
          contentType: "application/json",
          beforeSend: (req) => {
            req.setRequestHeader('Authorization', `Bearer ${this.$auth.token()}`)
          },
          data: (d) => {
            return this.mountedFilter();
          },
        },
        columns: this.columns,
        columnDefs: [
          {
            className: "nowrap",
            targets: 2
          },
          {
            className: "nowrap golden-day-icon",
            targets: 14,
            render: (data, type, row) => {
              if (data) {
                return '<i class="fas fa-check-square"></i>'
              }
              return '--';
            }
          }
        ],
        order: [[0, "desc"]],
        dom:
          '<"row"<"pl-3"l>>Brt<"row"<"col-sm-12 col-md-5"i><"col-sm-12 col-md-7"p>>',
        buttons: this.buttons,

      });
    this.listCommission.buttons().container().appendTo("#dt-actions");
  }

  /**
   * Method mounted from life cycle
   */
  private async mounted() {
    let self = this;

    this.$.fn.dataTable.ext.buttons.filter = {
      text: '<i class="fas fa-filter"></i>',
      className: "datatable-buttons mr-2 pr-0 pl-0",
      titleAttr: "Filtrar",
      action: function (e, dt, node, config) {
        self.$bvModal.show("modal-filter");
      },
    }

    this.$.fn.dataTable.ext.buttons.addbonus = {
        text: '<i class="fas fa-user-plus"></i>',
        className: "datatable-buttons mr-2 pr-0 pl-0",
        titleAttr: "Adicionar bonus",
        action: function (e, dt, node, config) {
            self.$bvModal.show("modal-add-bonus");
        }
    }

    this.getDataComissionScrean();
    this.createDataTable(this);

    const commission = await this.commissionService.commissionStatement(this.mountedFilter());

    this.sumCommissions = commission.data.reduce(
        (a, b) => a + parseFloat(b.commission_value.replace('R$', '').replace(',', '.')), 0
    );

  }

  private async saveBonusComission(){
    if(!this.bonusComission.bonus_value){
        this.hideModal("modal-add-bonus");
        return this.$store.commit("navBarAlert/DANGER_ALERT", 'Comissão está sem valor.');
    }

    if(!this.bonusComission.user_id){
        this.hideModal("modal-add-bonus");
        return this.$store.commit("navBarAlert/DANGER_ALERT", 'Consultor invalido.');
    }

    if(!this.bonusComission.bonus_id){
        this.hideModal("modal-add-bonus");
        return this.$store.commit("navBarAlert/DANGER_ALERT", 'Bonus invalido.');
    }

    if(!this.bonusComission.date || (this.$moment(this.bonusComission.date) as any).format("YYYY-MM-DD") > (this.$moment() as any).format("YYYY-MM-DD")){
        this.hideModal("modal-add-bonus");
        return this.$store.commit("navBarAlert/DANGER_ALERT", 'Data invalida');
    }
    this.hideModal("modal-add-bonus");

    const userService = new UserService();
    this.bonusComission.date = (this.$moment(this.bonusComission.date) as any).format("YYYY-MM-DD");
    this.bonusComission.bonus_id = this.bonusComission.bonus_id.id;
    this.bonusComission.squad_id = this.bonusComission.squad_id.id_squad;
    this.bonusComission.user_id = this.bonusComission.user_id.id_user;

    const result = await userService.saveBonusCommission(this.bonusComission);
    if (result == "Bonus inserted successfully.") {
        this.$store.commit("navBarAlert/SUCCESS_ALERT", 'Bonus inserido com sucesso.');
    } else {
      this.$store.commit("navBarAlert/DANGER_ALERT", 'Erro ao inserir o bonus. Por favor, tente novamente mais tarde.');
    }
    this.clearBonus();
  }

  private hideModal(modal_id: string) {
    this.$bvModal.hide(modal_id);
  }

  /**
   * Method before create from life cycle
   */
  private beforeCreate() {
    document.body.className = "";
  }

  private closeExportDataModal() {
    this.hideModal("modal-export-data");
  }

    private async getDataComissionScrean(){
      const userService = new UserService()
      const squadService = new SquadService()

      this.user_squad = (await userService.userList(this.$auth.user().id_platform)).body.filter(user => user.id_profile == 3 && user.id_status == 35);
      this.listBonus = (await userService.bonusList()).body;
      this.listSquad = (await squadService.show(this.$auth.user().id_platform));

  }

  private async allDataToExport() {
    if (this.listCommission.ajax.json() !== undefined) {
      let d = this.mountedFilter();

      let results = await this.commissionService.commissionStatement(d);

      for (const key in results) {
        if (results.hasOwnProperty(key)) {
          const element = results[key];
          Array.prototype.push.apply(results, element.data);
        }
      }

      this.listCommission.clear();
      this.listCommission.rows.add(results.data);
      this.listCommission.draw();

      this.$.fn.dataTable.ext.buttons[this.exportFormat].action.call(
        this.listCommission.button(this),
        null,
        this.listCommission,
        null,
        this.$.fn.dataTable.ext.buttons[this.exportFormat]
      );

      this.closeExportDataModal();
    }
  }
}
